<template>
  <div class="container-fluid p-0 m-0">


    <b-alert show fader variant="warning">
      <div style="font-size: 1.2rem;" class="text-danger"><b-icon icon="exclamation-circle-fill" variant="danger"></b-icon> {{$t('attention')}}</div>
       {{ $t('temp_not_accepting_orders__new_year_reason') }}
    </b-alert>

    <ViewImage ref="viewImage" />
    <cartComponent ref="cartComponent" showModal="showModal" @updateCart="updateCart" />
    <p class="h4 font-italic welcome-text"><b>{{ $t('online_shop') }}</b></p>
    <div class="container-fluid p-0 m-0 border-top border-bottom">
      <div class="row justify-content-center m-3">
        <div class="col-sm-12 col-md-6 mt-sm-2 mt-md-0">
          <b-form-select @change="filterProducts" class="select-filter-option" v-model="filterSelected" :options="filterOptions"></b-form-select>
        </div>
        <div class="col-sm-12 col-md-6 mt-md-0 mb-md-0 mt-sm-2" id="fixedCart">
          <span @click="showCartModal" class="courser-pointer">
            <img class="mt-2 shopping-basket" alt="shopping basket" src="@/assets/shopping-basket.svg">
            <b-badge v-if="productsCount" class="text-light shopping-basket-badge" pill variant="warning">{{ productsCount }}</b-badge>
          </span>
        </div>
      </div>
    </div>
    <div class="container-fluid mt-5">
      <div class="row justify-content-center">
        <div class="m-0 p-0" v-for="product in products" v-bind:key="product.id">
          <div v-if="product" class="col-3 mb-5 cursor-pointer">
            <img
              width="200"
              height="200"
              :alt="product.fields.name_en"
              :src="`${$request}media/${product.fields.image}`"
              @click="handleShowImage($event, product.fields['name_'+getCurrentLanguage()], product.fields['description_'+getCurrentLanguage()])" />
            <span v-if="product.fields.special_offer" class="special">{{ $t('special_offer') }}</span>
            <p class="text-center mb-0 width-image-size name-container">{{product.fields['name_' + getCurrentLanguage()]}}</p>
            <p class="text-center price width-image-size">
              <span class="mr-2" :class="+product.fields.discounted_price? 'text-del text-danger' : ''">{{Math.round(product.fields.price)}} {{ $t('amd') }} </span>
              <span v-if="+product.fields.discounted_price"> {{Math.round(product.fields.discounted_price)}} {{ $t('amd') }}</span>
            </p>
            <div class="btn-group" role="group">
              <b-button variant="outline-dark" class="toggle-btn" @click="toggleQty('-', product.pk)">-</b-button>
              <b-button variant="outline-dark" class="text-warning p-qty"  disabled><b>{{cart[product.pk] ? cart[product.pk].qty : ''}}</b></b-button>
              <b-button variant="outline-dark" class="toggle-btn" @click="toggleQty('+', product.pk)">+</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="message-modal" hide-footer>
      <div v-if="orderIsSuccess" class="text-center">
        <p class="h3"><b-icon icon="check-circle" variant="success"/></p>
        <p class="text-warning mt-2">{{ $t('tanks_for_choose') }} <b-icon icon="emoji-smile" variant="warning" /></p>
        <p class="font-italic mt-2 modal-text-information">{{ $t('order_success_accepted') }}</p>
      </div>
      <div v-if="!orderIsSuccess">
        <p class="text-center h3"><b-icon icon="exclamation-circle" variant="danger"/></p>
        <p class="text-danger text-center h5">{{ $t('order_went_wrong') }}</p>
        <div style="height: 100%;" class="text-center">
          <div class="mb-3 mt-3 border-bottom border-dark">
            <b-icon icon="telephone-fill" aria-hidden="true" />
            <a :href="'tel:'+getPhoneNumbers()[0]" class="ml-3 text-dark">
              {{getPhoneNumbers()[0]}}
            </a>
            <a v-if="getPhoneNumbers()[1]" :href="'tel:'+getPhoneNumbers()[1]" class="ml-3 text-dark">
              {{getPhoneNumbers()[1]}}
            </a>
          </div>
          <a :href="'viber://contact?number=%2B'+getPhoneNumbers()[0].substring(1)" target="_blank" class="mr-4"><img width="48" alt="viber" src="@/assets/icons8-viber.svg"></a>
          <a :href="'https://api.whatsapp.com/send?phone='+getPhoneNumbers()[0].substring(1)" target="_blank" class="mr-4"><img width="51" alt="whatsapp" src="@/assets/icons8-whatsapp.svg"></a>
          <a href="https://www.facebook.com/PaninoAm/" target="_blank"><img width="48" alt="messenger" src="@/assets/icons8-facebook-messenger.svg"></a>
        </div>
      </div>
    </b-modal>
    <div class="cart-float-wrap" v-show="viewFixedElement">
<!--      <p onclick="window.scrollTo({ top: 0, behavior: 'smooth' })" class="h1 courser-pointer font-weight-bold">-->
<!--        <b-icon icon="arrow-up-circle" variant="dark"/>-->
<!--      </p>-->
      <div>
        <span @click="showCartModal" class="courser-pointer cart-float-div">
          <img class="mt-2 shopping-basket" alt="shopping basket" src="@/assets/shopping-basket.svg">
          <b-badge v-if="productsCount" class="text-light shopping-basket-badge" pill variant="dark">{{ productsCount }}</b-badge>
        </span>
      </div>
    </div>
    <b-modal ref="idram_success" size="lg" hide-footer centered>
      <div class="text-center">
        <p class="h3"><b-icon icon="check-circle" variant="success"/></p>
        <p class="h5 text-success">{{ $t('payment_success') }}</p>
        <p class="h5 text-success">{{ $t('order_success') }}</p>
        <p class="font-italic mt-2 modal-text-information">{{ $t('order_success_accepted') }}</p>
      </div>
    </b-modal>
    <b-modal ref="idram_fail" size="lg" hide-footer centered>
      <p class="text-center h3"><b-icon icon="exclamation-circle" variant="danger"/></p>
      <p class="text-danger text-center h5">{{ $t('order_went_wrong') }}</p>
      <div style="height: 100%;" class="text-center">
        <div class="mb-3 mt-3 border-bottom border-dark">
          <b-icon icon="telephone-fill" aria-hidden="true" />
          <a :href="'tel:'+getPhoneNumbers()[0]" class="ml-3 text-dark">
            {{getPhoneNumbers()[0]}}
          </a>
          <a v-if="getPhoneNumbers()[1]" :href="'tel:'+getPhoneNumbers()[1]" class="ml-3 text-dark">
            {{getPhoneNumbers()[1]}}
          </a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Vue from "vue";

import CartComponent from "./cartComponent";
import ViewImage from "./ViewImage";


export default {
  name: "ShopPage",
  components: {
    CartComponent,
    ViewImage
  },
  comments: {
    CartComponent
  },
  data(){
    return {
      filterSelected: 'All',
      filterOptions: [
        { value: 'All', text: this.$t('all') },
        { value: 'Cake', text: this.$t('cakes') },
        { value: 'Pie', text: this.$t('pies') },
        { value: 'Other', text: this.$t('other') }
      ],
      products: this.$products,
      spinButtonValue: {},
      cart: this.$cookies.get('cart')? this.$cookies.get('cart') : {},
      productsCount: 0,
      orderIsSuccess: null,
      xSVG: require('@/assets/x.svg'),
      checkSVG: require('@/assets/check.svg'),
      fixedCartOffsetTop: 0,
      viewFixedElement: false
    }
  },
  watch: {
    '$i18n.locale': function() {
      this.filterOptions = [
        { value: 'All', text: this.$t('all') },
        { value: 'Cake', text: this.$t('cakes') },
        { value: 'Pie', text: this.$t('pies') },
        { value: 'Other', text: this.$t('other') }
      ]
    }
  },
  mounted() {
    this.filterProducts(this.filterSelected)
    let spinButtonValue = {}
    if(this.cart){
      Object.keys(this.cart).map(cartElementKey => {
        spinButtonValue[cartElementKey] = this.cart[cartElementKey].qty
      })
      this.spinButtonValue = spinButtonValue
    }
    this.fixedCartOffsetTop = document.querySelector('#fixedCart').offsetTop
    window.addEventListener('scroll', this.handleScrollEvent);
    this.handleHashAlerts()
    this.productsCount = 0
    Object.keys(this.cart).forEach(key => {
      this.productsCount += this.cart[key].qty
    })
  },
  methods: {
    handleHashAlerts(){
      const hash = window.location.hash
      if(hash){
        this.$refs[hash.substr(1)].show()
        window.location.hash = ''
      }
    },
    getCurrentLanguage(){
      return this.$i18n.locale
    },
    updateCart(){
      this.cart = this.$cookies.get('cart')
      this.productsCount = 0
      Object.keys(this.cart).forEach(key => {
        this.productsCount += this.cart[key].qty
      })
    },
    toggleQty(toggle, pk){
      if(toggle === '+'){
        if(this.cart[pk]){
          if(this.cart[pk].qty !== 99){
            this.cart[pk].qty = this.cart[pk].qty + 1
          }
        } else {
          this.cart[pk] = {qty: 1}
        }
      }
      if(toggle === '-' && this.cart[pk]){
        if(this.cart[pk].qty !== 1){
          this.cart[pk].qty = this.cart[pk].qty - 1
        } else {
          delete this.cart[pk]
        }
      }
      this.$nextTick(() => {
        Vue.$cookies.set("cart", this.cart, '30d')
        this.productsCount = 0
        Object.keys(this.cart).forEach(key => {
          this.productsCount += this.cart[key].qty
        })
      })
    },
    spinBtn(t){
      console.log(t)
      Object.keys(this.spinButtonValue).forEach(key => {
        if(this.spinButtonValue[key] === 100){
          delete this.spinButtonValue[key]
          if(this.cart[key]){
            delete this.cart[key]
          }
        } else{
          this.cart[key] = {qty: this.spinButtonValue[key]}
        }
      })
      this.$nextTick(() => {
        Vue.$cookies.set("cart", this.cart, '30d')
        this.productsCount = 0
        Object.keys(this.cart).forEach(key => {
          this.productsCount += this.cart[key].qty
        })
      })
    },
    filterProducts(filter){
      if(filter === 'All'){
        this.products = this.$products
      } else {
        let filteredProducts = []
        for(let product in this.$products){
          if(this.$products[product].fields.type === filter){
            filteredProducts.push(this.$products[product])
          }
        }
        this.products = filteredProducts
      }
    },
    showCartModal(){
      this.$refs.cartComponent.showModal()
    },
    orderMessage(isSuccess){
      this.$refs['message-modal'].show()
      this.orderIsSuccess = isSuccess
    },
    getPhoneNumbers(){
      if(this.$configs){
        return [this.$configs.fields.contact_number, this.$configs.fields.contact_number_second]
      }
      return []
    },
    handleShowImage(el, name, description) {
      this.$refs.viewImage.showModal(el.target.src, name, description);
    },
    handleScrollEvent(){
      this.viewFixedElement = window.scrollY > this.fixedCartOffsetTop
    }
  }
}
</script>

<style scoped>
.welcome-text{
  color: #392A20;
}
.custom-select{
  color: #5C3622;
}
.custom-select:focus{
  border-color: #392A20;
  box-shadow: none;
}
.select-filter-option{
  max-width: 200px;
}
.shopping-basket{
  width: 28px;
  filter: invert(31%) sepia(165%) saturate(900%) hue-rotate(-7deg) brightness(78%) contrast(76%);
}
.shopping-basket-badge{
  top: -7px;
  right: 4px;
  position: relative;
  font-size: 75%;
  vertical-align: baseline;
  background-color: #c35614;
}
.courser-pointer{
  cursor: pointer;
}
.courser-pointer:hover{
  color: #392A20 !important;
}
.price{
  font-size: 12px;
}
.text-del{
  text-decoration: line-through;
}
.special{
  width: 200px;
  position: absolute;
  bottom: 123px;
  left: 15px;
  font-size: 12px;
  font-style: italic;
  font-weight: bolder;
  color: #FFBE0B;
  text-shadow: 1px 0px #392A20;
  border: 3px dotted #5C3622;
}
.width-image-size{
  width: 200px;
}
.b-form-spinbutton{
  width: 155px;
}
.modal-text-information{
  color: #392A20;
}
.modal-text-success{
  color: #FFBE0B;
}
.cursor-pointer{
  cursor: pointer;
}
.cart-float-wrap{
  position: fixed;
  right: 15px;
  bottom: 15px;
  z-index: 100;
}
.cart-float-div{
  margin: auto;
  width: 74px;
  height: 74px;
  padding-top: 16px;
  display: block;
}
.cart-float-wrap svg{
  filter: drop-shadow(0px 0px 1px #ffffff) drop-shadow(0px 0px 1px #ffffff) !important;
}
.cart-float-wrap img{
  filter: drop-shadow(0px 0px 5px #ffffff) drop-shadow(0px 0px 0px #ffffff) !important;
}
.cart-float-div span{
  background-color: #000000;
  filter: drop-shadow(0px 0px 5px #ffffff) drop-shadow(0px 0px 0px #ffffff) !important;
}
.p-qty{
  width: 100px;
}
.p-qty b{
  color: #1c1c1c;
}
.toggle-btn{
  width: 50px;
}
.name-container{
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/ShopPage.vue